<template>
  <div id="userLogin">
    <div>
      <h2>
        <!-- <svg class="icon" aria-hidden="true">
          <use xlink:href="#se-icon-elephant"></use>
        </svg> -->
        <span>确认手机号</span>
      </h2>
      <form>
        <div>
          <keep-alive>
            <se-autocomplete
              v-model="iccid"
              :fetchsuggestions="querySearch"
              @select="handleSelect"
              placeholder="请输入要查询的卡号"
            ></se-autocomplete>
          </keep-alive>
        </div>
        <div class="formLine">
          <mt-button type="primary" style="background:#0066FF" size="large" @click.prevent="userQuerySIM"
            >查 询 绑 定</mt-button
          >
        </div>
      </form>
    </div>

    <p style="text-align: center;font-size: 10px;margin-top:1rem;color:red">提醒：请确保手机号绑定正确，方便后续为您提供更优质的售后服务</p>
    <!-- <img
      style="width: 100%; margin-top: 1rem;"
      src="@/assets/advertising3.jpg"
      alt=""
      @click="goto('http://szyanyun.com/download.html')"
    /> -->
    <!-- <button class="download" @click="goto('http://szyanyun.com/download.html')" >点击下载</button> -->

    <!-- <Advertisement></Advertisement> -->
  </div>
</template>
<script>
import {	Dialog	} from 'vant';
import { Toast } from 'vant';
import { wxRequest } from '@/api/user.js' 
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
    components: {SeAutocomplete,Advertisement},
    data(){
        return {
            iccid: '',
            code: '',
            showAds: true,
            gzh:'',
            realNameList: ['1192351241053663232', '1224969664338063360', '1255666672321163264', '7DA692EC992B45E297450F40DEDC5614', '8601954A2B074E80AACAAF32C5EE232C', 
            '960F3276EFAA4ED2999754895F4BCCB4', 'B1E112B9F1D8420E9072D9F47D6A135E', '1275705014286807040', 
            '1275706083402313728', '1274979554988912640', '1279289937396494336'],
            suolangList: ['1275704520822747136']
        }
    },
    methods: { 
        querySearch(queryString, cb) {
            var listAll = this.getAutoCompleteData('iccidList');         
            var results = queryString ? listAll.filter(this.createFilter(queryString)) : listAll;      
            cb(results);      
        },
        createFilter(queryString) {
            return (listAll) => {
                return (listAll.indexOf(queryString) == 0);
            };
        },
        handleSelect(item){
            this.iccid = item 
        },       
        userQuerySIM(){
            if(this.iccid == ''){
                Dialog.alert({title: '提示', message:'请输入ICCID号'})
                return false;
            }

            let recordLoginText = this.iccid;//存放用户登录时输入的文本，将用于首页显示

            let data = {
                requestId: this.iccid,
                code: this.code
            }
			wxRequest("sim/bind",data, "get").then(res => {
                if(res.data.code == 200){
                    let record = res.data.data;
                    let iccid = record.iccid;
                    
					          localStorage.setItem('mobile', record.mobile);
                    localStorage.setItem("userPhone", record.userPhone);
                    localStorage.setItem('supplierTypeName', record.supplierTypeName);
                    localStorage.setItem('wxHeadImg', record.wxHeadImg);
                    localStorage.setItem('wxNickName', record.wxNickName);
                    localStorage.setItem('recordLoginText', recordLoginText);
                    localStorage.setItem('supplierName', record.supplierName);
                    localStorage.setItem('iccid', iccid);
                    localStorage.setItem('intoNo', record.intoNo);
                     localStorage.setItem('yucun', record.yucun);
                    localStorage.setItem('openId', record.openId);
                    localStorage.setItem('agentId', record.agentId);
                    localStorage.setItem('flowRatePool', record.flowRatePool);
                    localStorage.setItem("ishavePkg", record.ishavePkg);
                    localStorage.setItem("isSale", record.isSale);
                    localStorage.setItem("kefuUrl", record.kefuUrl);
                    localStorage.setItem("priceImgUrl", record.priceImgUrl); 
                    localStorage.setItem("ishavePrice", record.ishavePrice);
                    this.$store.state.recordLoginText = recordLoginText;
                    this.$store.state.supplierCode = res.data.data.supplierCode;                 
                    this.$store.state.iccid = iccid;
                    this.$store.state.flowRatePool=res.data.data.flowRatePool;
                    this.$store.state.userPhone = record.userPhone;
                    this.$store.state.intoNo = record.intoNo;
                    this.setAutoCompleteData('iccidList', recordLoginText, 10)
                    //未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
                    let cardType = record.supplierCode;
                    if(!record.userPhone){
                          Dialog.confirm({title:'温馨提示', message:'未查询到此卡号绑定的手机号，点击确认前往绑定.'}).then(action => {
                             if(action == 'confirm'){
                                this.$router.push({
                                         path:'/user/bindPhoneOnely',
                                        query:{
                                             iccid: record.iccid
                                         }
                                     });
                             }
                         })
                    }else{
                       this.$router.replace("/user/bindPhoneList");
                    }
                }else{
                    Dialog.alert({title: '提示', message:res.data.message});
                }
            })
        },


        //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
        
        goBuyCard() {
            window.location.href = 'http://10086.sm.iot000.cn/#/user/login2'
        }

        // goto(path){
        //     //广告点击统计
        //     wxRequest("link/click",{url: path}, "get").then(res => {
        //         window.location.href = path;
        //     });
            
        // },


    },
    created(){
        var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
        localStorage.setItem('appid', source);
        localStorage.setItem('isHeadquarterAppid', false);
        var appid  = source ? source : process.env.VUE_APP_APPID;

        console.log(appid)
     
        //先查询是否是乐刷支付 如果是乐刷支付 就不用授权了
        	wxRequest("sim/get/pay/state", {
					iccid: localStorage.getItem('iccid')
				}, 'post').then(res => {
                    localStorage.setItem('payCode',res.data.code);
					if (res.data.code == 200) {
						localStorage.setItem('leshuaPay',1);
                         this.code = "leshua";
                     this.iccid = localStorage.getItem('recordLoginText');
					} else {
          var redirectUrl = window.location.href;   
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
					localStorage.setItem('leshuaPay',2);
                       if (index < 0) {
       window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
    } else {
            var search = window.location.search;
            console.log('search',search);
            var startIndex = search.indexOf('code');
            var endIndex = search.indexOf('&', startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf('=') + 1);
            this.code = code;
            this.iccid = localStorage.getItem('recordLoginText');
    }

					}
				})
        
     
        //获取总部公众号appid
		wxRequest("/sim/appId",{}, "post").then(res => {
            if(res.data.code == 200){
                if(appid != res.data.data.collectAppid ){
                    this.$store.commit('setIsHeadquarterAppid', 'false');
                    localStorage.setItem('isHeadquarterAppid', false);
                }else{
                    this.$store.commit('setIsHeadquarterAppid', 'true');
                    localStorage.setItem('isHeadquarterAppid', true);
                }      
            }
        });

    },

    mounted() {

    },


    beforeDestory(){
       
    }
}
</script>


<style lang="less" scoped>
.download {
  position: relative;
  top: -63px;
  background: #ff9c3c;
  border: none;
  padding: 7px 13px;
  border-radius: 25px;
  font-size: 12px;
  color: #fff;
  left: 20%;
}
</style>
